import { render, staticRenderFns } from "./classDropdown.vue?vue&type=template&id=d554f6f6&scoped=true"
import script from "./classDropdown.vue?vue&type=script&lang=js"
export * from "./classDropdown.vue?vue&type=script&lang=js"
import style0 from "./classDropdown.vue?vue&type=style&index=0&id=d554f6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d554f6f6",
  null
  
)

export default component.exports